<ng-container *ngIf="loading$ | async; else dropArea">
    <div class="skeleton w-full h-full"></div>
</ng-container>

<ng-template #dropArea>
    <button
        *ngIf="(url$ | async) === null; else imageArea"
        class="w-full h-full flex items-center justify-center p-2 border border-dashed border-outline-variant hover:border-accent hover:cursor-pointer bg-surf-container-lowest rounded overflow-hidden"
        (click)="processUpload()"
    >
        <div class="flex flex-col items-center justify-center gap-2">
            <span class="text-accent">{{ label }}</span>
            <div *ngIf="editable" class="text-secondary text-sm leading-4 text-center">
                <ng-content />
            </div>
        </div>
    </button>
</ng-template>

<ng-template #imageArea>
    <div
        class="w-full h-full relative flex items-center justify-center bg-surf-container-lowest border border-solid border-outline-variant rounded group overflow-hidden"
    >
        <img
            [src]="url$ | async"
            [alt]="name$ | async"
            [ngClass]="{ 'max-w-full': previewWidth === null, 'max-h-full': previewHeight === null }"
            [attr.width]="previewWidth"
            [attr.height]="previewHeight"
        />
        <div
            *ngIf="editable"
            class="absolute bg-surf-container-lowest right-0 left-0 bottom-0 h-8 px-1 z-10 hidden items-center justify-end group-hover:flex"
        >
            <fui-button
                type="button-icon"
                [title]="dictionary.system_del"
                color="flat"
                icon="trash-can-outline"
                height="slim"
                borderRadius="circle"
                (clickEvent)="onRemove()"
            >
            </fui-button>
        </div>
    </div>
</ng-template>
